






















import { combinedAddress, addressType } from '../../api/';
export default {
  name: 'AdviserDetails',
  props: ['data'],
  computed: {
    adviserDetails() {
      return this.data.investment.adviserDetails;
    },
    adviserAddress() {
      return combinedAddress(
        {
          addressLine1: this.adviserDetails.addressLine1,
          addressLine2: this.adviserDetails.addressLine2,
          addressLine3: this.adviserDetails.addressLine3,
          suburb: this.adviserDetails.suburb,
          state: this.adviserDetails.state,
          postCode: this.adviserDetails.postcode,
          countryCode: this.adviserDetails.countryCode,
        },
        addressType.residentialAddress
      );
    },
  },
};
